export default __webpack_public_path__ + "static/media/pensionsdagen2026.28e27cdf.jpg";